export default "__VITE_ASSET__4e70e72f__"